import { appLangLink } from '@bcf2-v1-ui-routes/app-lang-link';
import { msg } from '@lit/localize';
import type { FooterLinksConfig } from '../types';

export const footerLinks = (): FooterLinksConfig => [
  {
    title: msg('General info'),
    links: [
      {
        label: msg('Terms and Conditions'),
        url: appLangLink('/sp/terms-and-conditions/')
      },
      {
        label: msg('Bonus terms'),
        url: appLangLink('/sp/bonus-terms/')
      },
      {
        label: msg('Privacy policy'),
        url: appLangLink('/sp/privacy-policy/')
      },
      {
        label: msg('Responsible gambling'),
        url: appLangLink('/sp/responsible-gaming/')
      },
      {
        label: msg('Refund policy'),
        url: appLangLink('/sp/refund-policy/')
      },
      {
        label: msg('Affiliate program'),
        url: 'https://betterplay.partners/'
      },
      {
        label: msg('Support'),
        url: appLangLink('/support/')
      }
    ]
  },
  {
    title: msg('Promotions'),
    links: [
      {
        label: msg('All Promotions'),
        url: appLangLink('/promotions/')
      },
      {
        label: msg('Tournaments'),
        url: appLangLink('/tournaments/')
      },
      {
        label: msg('Mobile app'),
        url: appLangLink('/lp/mobile-application/')
      }
    ]
  },
  {
    title: msg('Casino'),
    links: [
      {
        label: msg('New'),
        url: appLangLink('/collection/new-games/')
      },
      {
        label: msg('Popular'),
        url: appLangLink('/collection/best-slots/')
      },
      {
        label: msg('Jackpots'),
        url: appLangLink('/jackpot-slots/')
      },
      {
        label: msg('Only with Janusz'),
        url: appLangLink('/collection/exclusive-collection/')
      },
      {
        label: msg('Fruits'),
        url: appLangLink('/collection/fruit-slots/')
      },
      {
        label: msg('Classic'),
        url: appLangLink('/collection/classic-slots/')
      },
      {
        label: msg('Books'),
        url: appLangLink('/collection/book-slots/')
      },
      {
        label: msg('Buy Feature'),
        url: appLangLink('/collection/bonus-buy/')
      },
      {
        label: msg('Megaways'),
        url: appLangLink('/collection/megaways/')
      },
      {
        label: msg('Other'),
        url: appLangLink('/collection/other/')
      },
      {
        label: msg('Scratchcards'),
        url: appLangLink('/collection/scratch-cards/')
      }
    ]
  },
  {
    title: msg('Live Casino'),
    links: [
      {
        label: msg('New Live Games'),
        url: appLangLink('/collection/new-live-casino/')
      },
      {
        label: msg('Best Live Games'),
        url: appLangLink('/collection/best-live-casino/')
      },
      {
        label: msg('Live Roulette'),
        url: appLangLink('/collection/live-roulette/')
      },
      {
        label: msg('Live Blackjack'),
        url: appLangLink('/collection/live-blackjack/')
      },
      {
        label: msg('Live Game Shows'),
        url: appLangLink('/collection/live-game-shows/')
      },
      {
        label: msg('Live Poker'),
        url: appLangLink('/collection/live-poker/')
      },
      {
        label: msg('Live Baccarat'),
        url: appLangLink('/collection/live-baccarat/')
      },
      {
        label: msg('Providers Live Casino'),
        url: appLangLink('/collection/providers-live-casino/')
      }
    ]
  },
  {
    title: msg('Table Games'),
    links: [
      {
        label: msg('Table Games'),
        url: appLangLink('/collection/table-games/')
      },
      {
        label: msg('Roulette'),
        url: appLangLink('/collection/roulette/')
      },
      {
        label: msg('Baccarat'),
        url: appLangLink('/collection/baccarat/')
      },
      {
        label: msg('Blackjack'),
        url: appLangLink('/collection/blackjack/')
      }
    ]
  },
  {
    title: msg('Jackpots'),
    links: [
      {
        label: msg('Dream Drop'),
        url: appLangLink('/collection/dream-drop/')
      },
      {
        label: msg('Mega Moolah'),
        url: appLangLink('/collection/mega-moolah/')
      }
    ]
  }
];
